var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material Symbols and Icons 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99998 11.8413L5.7981 8.63944L6.58847 7.82599L8.4375 9.67502V3.375H9.56246V9.67502L11.4115 7.82599L12.2019 8.63944L8.99998 11.8413ZM4.73077 14.625C4.35193 14.625 4.03125 14.4937 3.76875 14.2312C3.50625 13.9687 3.375 13.648 3.375 13.2692V11.2356H4.49998V13.2692C4.49998 13.3269 4.52402 13.3798 4.57209 13.4279C4.62018 13.4759 4.67308 13.5 4.73077 13.5H13.2692C13.3269 13.5 13.3798 13.4759 13.4279 13.4279C13.4759 13.3798 13.5 13.3269 13.5 13.2692V11.2356H14.625V13.2692C14.625 13.648 14.4937 13.9687 14.2312 14.2312C13.9687 14.4937 13.648 14.625 13.2692 14.625H4.73077Z",
    fill: "#2196F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.9569d9076d545fed1f48e364f4f78f17.svg";
export { ForwardRef as ReactComponent };